import { AbpModule } from '@abp/abp.module';
import * as ngCommon from '@angular/common';
import { NgModule, ErrorHandler } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClientJsonpModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ServiceProxyModule } from '@shared/service-proxies/service-proxy.module';
import { UtilsModule } from '@shared/utils/utils.module';
import { FileUploadModule } from 'ng2-file-upload';
import { ModalModule, TabsModule, TooltipModule, BsDropdownModule } from 'ngx-bootstrap';
import { FileUploadModule as PrimeNgFileUploadModule, PaginatorModule, ProgressBarModule, SharedModule } from 'primeng/primeng';
import { TableModule } from 'primeng/table';
// import { AppCommonModule } from './shared/common/app-common.module';
import { ImageCropperModule } from 'ngx-image-cropper';
import { HttpModule, Http } from '@angular/http';
import { MySettingsModalComponent } from '../layout/profile/my-settings-modal.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { SmsVerificationModalComponent } from '../layout/profile/sms-verification-modal.component';



@NgModule({
  imports: [
     ngCommon.CommonModule,
            FormsModule,
            ReactiveFormsModule,
            HttpClientModule,
            HttpClientJsonpModule,
            ModalModule.forRoot(),
            TooltipModule.forRoot(),
            TabsModule.forRoot(),
            BsDropdownModule.forRoot(),
            BsDatepickerModule.forRoot(),
            FileUploadModule,
            AbpModule,
            UtilsModule,
            ServiceProxyModule,
            TableModule,
            PaginatorModule,
            PrimeNgFileUploadModule,
            ProgressBarModule,
            ImageCropperModule
  ],
  declarations: [
    MySettingsModalComponent,
    SmsVerificationModalComponent
  ],
  exports: [
    MySettingsModalComponent,
    SmsVerificationModalComponent
  ],
})
export class SharedModuleModule { }
